/* import external modules */
import React, { useState } from 'react'

/* import internal modules */
import {
  Container,
  Toggle,
  MenuCollapsed,
  Label,
  ListItem,
  ListItemName,
  BlackoutMobile,
  ItemOption,
  ButtonExit,
  ItemsLabel,
  ExitLabel,
} from './styles'
import List from '../List'
import Icon from '../Icon'
import Img from '../../Common/Img'

const Menu = ({ nameUser, itemsMenu , selected, classt = false , campaigns}) => {
  let bandera = 0

  const ADS = campaigns?.filter((item) => { return item.productType === null || item.productType === 1 })
  const CONDOLENCE = campaigns?.filter((item) => { return item.productType === 2 })

  if(!CONDOLENCE?.length > 0 || !ADS?.length > 0){
    
    if(ADS?.length > 0){
      bandera = 1
    }

    if(CONDOLENCE?.length > 0){
      bandera = 1
    }

    if(CONDOLENCE?.length == 0 && ADS?.length == 0){
      bandera = 1
    }

  }

  const [active, setActive] = useState(false)

  const toggle = () => {
    setActive(!active)
  }

  const close = () => {
    setActive(false)
  }
  return (
    <>
      <BlackoutMobile active={active} onClick={close}>
        <Icon className="close-menu" icon="closeMenu" color="#ffffff" />
      </BlackoutMobile>
      <Container tabIndex="0" onBlur={close} >
        <Toggle active={active} onClick={toggle} className={classt.name_user}>
          <label>{nameUser}</label>
          <Icon className="desktop" icon="arrowDown" color="#ffffff" />
          <Icon className="mobile" icon="menu" color="#ffffff" />
        </Toggle>
        <MenuCollapsed className={`${active && 'active '+classt.sign_off}`}>
          <List>
            <ListItemName>{nameUser}</ListItemName>
            { bandera == 0 && (<div className='infoProducts'><Icon icon="menuItems" color="#4F5356" />Tus otros productos</div>)}
            {itemsMenu.filter(item => bandera == 0 ? item.type !== selected : item.type == 'Exit').map((item, index) => (              
              <ListItem key={index} onClick={item.onClick}>
                {item.type !== "Exit" ? (
                  bandera == 0 && (
                    <ItemOption onClick={toggle}>

                        <Img className="svgImg" src={item.icon} />
                      
                      <ItemsLabel >{item.label}</ItemsLabel>
                    </ItemOption>
                  )
                ) : (
                  <ButtonExit>
                    {bandera === 0 && <Label className="lineBorder" />}
                    <Icon className="svgIconExit" icon={item.icon} color="#0066A5" />
                    <ExitLabel>{item.label}</ExitLabel>
                  </ButtonExit>
                )}
              </ListItem>
            ))}
          </List>
        </MenuCollapsed>
      </Container>
    </>
  )
}

export default Menu
